import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    filterContainer: {
      display: "flex",
      flexDirection: "column",
      border: `1px solid ${theme.gray200}`,
      borderRadius: "8px",
      overflow: "visible",
      margin: theme.spacing(0, 0, 8, 0),
    },
    topFunctions: {
      alignItems: "center",
      backgroundColor: theme.gray50,
      borderBottom: ({
        isFilterContainerOpen,
      }: {
        isFilterContainerOpen: boolean;
      }) => (isFilterContainerOpen ? `1px solid ${theme.gray100}` : "none"),
      borderRadius: ({
        isFilterContainerOpen,
      }: {
        isFilterContainerOpen: boolean;
      }) =>
        isFilterContainerOpen ? theme.spacing(4, 4, 0, 0) : theme.spacing(4),
      display: "flex",
      justifyContent: "space-between",
      padding: theme.spacing(6, 8),
      width: "100%",
      gap: theme.spacing(16),
    },
    filterHeader: {
      maxWidth: "70%",
      gap: theme.spacing(2.5),
      width: "100%",
      textWrap: "nowrap",
    },
    filterName: {
      fontWeight: 600,
      color: theme.primary800,
      fontSize: 14,
    },
    codeAndArrowWrapper: {
      display: "flex",
      alignItems: "center",
      overflow: "hidden",
    },
    code: {
      fontSize: "14px",
      fontWeight: 400,
      color: theme.gray500,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    arrow: {
      width: "21px",
      height: "21px",
      color: theme.gray500,
      cursor: "pointer",
      transition: "0.2s",
      transform: ({
        isFilterContainerOpen,
      }: {
        isFilterContainerOpen: boolean;
      }) => (isFilterContainerOpen ? "rotate(0)" : "rotate(180deg)"),
    },
    filterEditMode: {
      padding: theme.spacing(12),
      borderTop: `1px solid ${theme.gray200}`,
      borderBottom: `1px solid ${theme.gray200}`,
    },
    conditionHeaderText: {
      fontSize: "14px",
      fontWeight: 500,
      color: theme.gray800,
    },
    savedConditionsHeader: {
      padding: theme.spacing(8, 8, 0),
      fontWeight: 500,
      fontSize: "14px",
      color: theme.gray800,
    },
    formButtons: {
      marginBottom: 0,
    },
    buttonWrapper: {
      padding: theme.spacing(8, 12),
    },
    input: {
      width: "100%",
      marginBottom: theme.spacing(12),
    },
    newConditionButtonDisabled: {
      "&:hover": {
        backgroundColor: theme.gray300,
        color: theme.gray600,
        border: "none",
      },
    },
    tooltipTitle: {
      fontWeight: 600,
      color: theme.primary800,
      marginBottom: theme.spacing(2),
      fontSize: 14,
    },
    andOperator: {
      color: theme.gray500,
      margin: theme.spacing(8, 0, 8, 8),
    },
    sidebar: {
      width: "550px",
    },
    header: {
      padding: theme.spacing(4, 4, 4, 8),
      backgroundColor: theme.gray50,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    footer: {
      position: "absolute",
      bottom: 0,
      height: "68px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: theme.spacing(8),
      borderTop: `1px solid ${theme.gray100}`,
      padding: theme.spacing(0, 8),
      backgroundColor: theme.white00,
    },
    container: {
      height: "calc(100% - 68px)",
      padding: theme.spacing(12),
      overflow: "auto",
      marginBottom: theme.spacing(30),
    },
    emptyState: {
      height: "100%",
    },
  }),
);
